import axios from "axios";
import authHeader from "./auth-header";

/**
 * Configuration runtime éditable (table cv_settings côté back).
 * - getSettings : schéma + valeurs courantes (secrets masqués → { hasValue }).
 * - postSettings : envoie les modifications (champ secret laissé vide = inchangé).
 * Le cookie httpOnly cv_token est joint automatiquement (axios withCredentials).
 */
class SettingsService {
  getSettings() {
    return axios.get(process.env.REACT_APP_API_URL + "settings", {
      headers: authHeader(),
    });
  }

  postSettings(values) {
    return axios.post(
      process.env.REACT_APP_API_URL + "settings",
      { values },
      { headers: authHeader() }
    );
  }
}

export default new SettingsService();
